import React, { useState } from "react";
import { auth } from "../firebase"; // adjust path as needed
import { reauthenticateWithCredential, EmailAuthProvider, updatePassword } from "firebase/auth";
import Button from 'react-bootstrap/Button';
import ModalWrapper from "./ModalWrapper";

const ChangePasswordModal = ({changePasswordOpen, setChangePasswordOpen}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setMessage("");
    
    if (newPassword !== confirmNewPassword) {
      setMessage("New passwords do not match.");
      return;
    }

    const user = auth.currentUser;
    if (!user || !user.email) {
      setMessage("No user is currently signed in.");
      return;
    }

    const credential = EmailAuthProvider.credential(user.email, currentPassword);

    try {
      setLoading(true);

      // Re-authenticate the user
      await reauthenticateWithCredential(user, credential);

      // Update the password
      await updatePassword(user, newPassword);

      setMessage("Password changed successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (error) {
      console.error("Error updating password:", error);
      setMessage(error.message || "Failed to change password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    changePasswordOpen && <ModalWrapper
            show={changePasswordOpen}
            onHide={() => setChangePasswordOpen(false)}
            heading="Change Password"
        >
      <form onSubmit={handlePasswordChange} className="">

        {message && <div className="alert alert-danger">{message}</div>}
            Current Password:
            <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            className="form-input"
            />

            New Password:
            <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="form-input"
            />

            Confirm New Password:
            <input
            type="password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
            className="form-input"
            />

        <Button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
        >
            {loading ? "Changing..." : "Change Password"}
        </Button>
        <Button className="btn btn-secondary" data-bs-dismiss="modal" 
          onClick={
              () => {
                  //reset edit fields
                  setCurrentPassword("")
                  setNewPassword("")
                  setConfirmNewPassword("")
                  setMessage("")
                  
                  setChangePasswordOpen(false)
              }
          }
        >Cancel</Button>
      </form>
    </ModalWrapper>
  );
};

export default ChangePasswordModal;